export const CustomShapeUIConfig = {
    PRODUCT: {
        BACK_LABEL: 'Back',
        TITLE: 'All-over Print Kid and Youth Satin Short-Sleeve Pajama Set',
        PRIMARY_ACTION_LABEL: 'Save',
    },
}
